<template>
  <CustomerLevelRow :customer="profile" class="gmf-customer-name" />
</template>

<script>
import state from '@/state';
import CustomerLevelRow from '@/components/CustomerLevelRow.vue';

export default {
  components: {
    CustomerLevelRow,
  },
  name: 'MyCustomerLevel',
  data () {
    return {
      state,
    };
  },
  computed: {
    profile() {
      return this.state.profile;
    }
  },
};
</script>
